import { FileIcon } from 'lucide-react';
import type { JSX } from 'react';

import { typeLabel } from './artifact-display.js';

/**
 * Shown when a file has no safe inline preview — a short prompt to download, not a metadata dump. `reason`
 * replaces the default wording when the type CAN be previewed but this file is not, such as one over the
 * size cap.
 */
export function NoPreview({
  name,
  contentType,
  reason,
}: {
  name: string;
  contentType: string;
  reason?: string;
}): JSX.Element {
  return (
    <div className="flex flex-col items-center gap-3 py-10 text-center">
      <span className="flex size-12 items-center justify-center rounded-2xl bg-muted text-muted-foreground">
        <FileIcon className="size-6" />
      </span>
      <p className="max-w-sm text-sm text-muted-foreground">
        {reason ??
          `${typeLabel(contentType, name)} files can't be previewed in the browser. Download it to open in the right app.`}
      </p>
    </div>
  );
}

/** Shown when a previewable file could not be fetched or opened — the download is the way forward. */
export function PreviewLoadError(): JSX.Element {
  return (
    <div className="rounded-lg border border-destructive/40 bg-destructive/5 p-4 text-sm text-destructive">
      Couldn't load this file for preview. Try downloading it instead.
    </div>
  );
}
